// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3kAAh","dragIcon":"Choice_dragIcon__3KYGM","left":"Choice_left__Z2SMn","input":"Choice_input__3EXT0"};